
export default function Purchase() {
  return (
    <section id="purchase-section" className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-3xl md:text-5xl font-bold text-[#0A2463] mb-4">
            Comece Sua Transformação Hoje
          </h2>
          <p className="text-lg md:text-xl text-gray-600">
            Investimento único com acesso vitalício
          </p>
        </div>

        <div className="bg-white rounded-2xl md:rounded-3xl shadow-2xl overflow-hidden border-4 border-[#FFB800]">
          <div className="bg-gradient-to-r from-[#0A2463] to-[#1E3A8A] text-white text-center py-4 md:py-6 px-4">
            <div className="inline-block bg-[#FFB800] text-[#0A2463] px-4 md:px-6 py-2 rounded-full text-xs md:text-sm font-bold mb-2">
              🔥 OFERTA ESPECIAL
            </div>
            <h3 className="text-xl md:text-3xl font-bold">
              Ebook Completo de Adestramento Canino
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 p-5 md:p-10">
            {/* Coluna Esquerda - Informações */}
            <div className="min-w-0">
              <div className="text-center md:text-left mb-6 md:mb-8">
                <div className="text-4xl md:text-6xl font-bold text-[#0A2463] mb-2">
                  R$ 47,90
                </div>
                <p className="text-sm md:text-base text-gray-600">
                  Pagamento único • Acesso imediato
                </p>
              </div>

              <div className="space-y-3 md:space-y-4 mb-6 md:mb-8">
                <div className="flex items-start gap-3">
                  <i className="ri-check-double-line text-[#FFB800] text-xl md:text-2xl mt-0.5 flex-shrink-0"></i>
                  <span className="text-sm md:text-base text-gray-700">
                    150+ páginas de conteúdo exclusivo e ilustrado
                  </span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-double-line text-[#FFB800] text-xl md:text-2xl mt-0.5 flex-shrink-0"></i>
                  <span className="text-sm md:text-base text-gray-700">Suporte via WhatsApp</span>
                </div>
              </div>

              <a
                href="https://pay.kiwify.com.br/YJEG8Y0"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full bg-[#FFB800] hover:bg-[#FFA500] text-[#0A2463] py-4 md:py-6 rounded-xl md:rounded-2xl text-base md:text-2xl font-bold transition-all duration-300 transform hover:scale-105 shadow-2xl cursor-pointer flex items-center justify-center gap-2 md:gap-3 px-4"
              >
                <i className="ri-shopping-cart-line text-xl md:text-3xl flex-shrink-0"></i>
                <span className="text-center leading-tight">
                  Quero Transformar Meu Cão Agora
                </span>
              </a>

              <div className="flex items-center justify-center gap-4 md:gap-6 mt-4 text-gray-600">
                <div className="flex items-center gap-1.5 md:gap-2">
                  <i className="ri-shield-check-line text-[#0A2463] text-base md:text-xl flex-shrink-0"></i>
                  <span className="text-xs md:text-sm">Compra 100% Segura</span>
                </div>
                <div className="flex items-center gap-1.5 md:gap-2">
                  <i className="ri-lock-line text-[#0A2463] text-base md:text-xl flex-shrink-0"></i>
                  <span className="text-xs md:text-sm">Dados Protegidos</span>
                </div>
              </div>
            </div>

            {/* Coluna Direita - Imagem do Ebook */}
            <div className="flex items-center justify-center mt-2 md:mt-0">
              <div className="relative w-full max-w-xs md:max-w-md">
                <div className="absolute inset-0 bg-gradient-to-br from-[#FFB800]/20 to-[#0A2463]/20 rounded-3xl blur-2xl"></div>
                <img
                  src="https://static.readdy.ai/image/d9a90a3a33c103674e2a9b61d59bf53a/6eddffe04fd8f0288fb517d388b2cf45.jpeg"
                  alt="Ebook de Adestramento Canino"
                  title="Ebook Completo de Adestramento Canino"
                  className="relative w-full h-auto object-contain drop-shadow-2xl transform hover:scale-105 transition-transform duration-300"
                  onError={(e) => {
                    const target = e.currentTarget as HTMLImageElement;
                    target.src =
                      "https://via.placeholder.com/400x600?text=Imagem+não+disponível";
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 md:mt-12 text-center">
          <p className="text-sm md:text-base text-gray-600 mb-4">
            <i className="ri-time-line text-[#FFB800]"></i> Mais de{' '}
            <strong>15.000 tutores</strong> já transformaram seus cães
          </p>
        </div>
      </div>
    </section>
  );
}
